module.exports = {
  image_path_server: process.env.REACT_APP_FARMAGEO_BUCKET, //incluir "/"
  apiFarmageo: process.env.REACT_APP_FARMAGEO_API,
  apiFarmageoSql: process.env.REACT_APP_FARMAGEO_API,
  authFarmageo: "https://admin.farmageo.com.ar:8000",
  base: "https://app.farmageo.com.ar",
  //apiFarmageo: "http://localhost:3110",
  //apiFarmageo: 'http://192.168.100.165:3110',
};
